const getStreamBrowser = (link) => {
  const sourceCheck = link.endsWith("m3u8");
  if (!sourceCheck) {
    window.open(
      link,
      "_blank",
      "width=730,height=605,resizable=yes,noopener, scrollbars=no"
    );
    return;
  }

  const videoWindow = window.open(
    `/live?url=${encodeURI(link)}`,
    ``,
    "scrollbars=no"
  );
  // Ensure the window content has loaded, then resize the window based on the video size
  videoWindow.onload = () => {
    // Wait for the video element to be ready
    const videoElement = videoWindow.document.querySelector("video");

    let windowWidth = 640;
    let windowHeight = 440;

    if (videoElement) {
      videoElement.onloadedmetadata = () => {
        // Get the natural dimensions of the video
        windowWidth = videoElement.videoWidth - 25;
        windowHeight = videoElement.videoHeight + 40;
      };
    }

    videoWindow.resizeTo(windowWidth, windowHeight);
  };
};

export { getStreamBrowser };
